// define a mixin object
const isMobileMixin = {
  data() {
    return {
      width: 144,
      isMobile: false,
      isTablet: false
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 425
      this.isTablet = window.innerWidth <= 768
      this.width = window.innerWidth
    }
  }
}

export default isMobileMixin



// WEBPACK FOOTER //
// ./src/mixins/isMobileMixin.js